<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
            <h5 class="card-title font-bold py-3">گزارش فاکتور باز</h5>
            <div style="flex: 1"></div>
            <button @click="print" class="btn btn-primary">
                <span
                style="transform: translateY(3px)"
                class="feather-printer"
                ></span>
            </button>
            </div>
            <div class="row px-4 not-in-print">
            <form
                style="width: 100%;"
                autocomplete="chrome-off"
                @submit.prevent="doFilter"
            >
                <div class="row mr-2 mb-2">
                    <CustomerSearch
                        :showLabel="false"
                        class="col-md-4"
                        :disabled="disabled"
                        v-model="selectedCustomer"
                    />
                    <b-form-group class="col-md-2">
                        <b-form-input
                            :disabled="disabled"
                            placeholder="شناسه"
                            v-model="miniOrderId"
                        >
                        </b-form-input>
                    </b-form-group>
                    <DatePickerRange
                        :fromFormatType="'YYYY-MM-DD'"
                        :toFormatType="'YYYY-MM-DD'"
                        :fromType="'date'"
                        :toType="'date'"
                        class="col-md-5"
                        :dfFType="'jYYYY-jMM-jDD'"
                        :dfTType="'jYYYY-jMM-jDD'"
                        v-model="filter.date"
                    />
                </div>
                <div class="col-2 d-flex mr-2">
                    <button :disabled="disabled" style="width: 100%;" type="submit" class="btn btn-primary">
                        فیلتر
                    </button>
                </div>
            </form>
            </div>
            <div id="print" class="p-4">
            <div class="print-only">
                <h4>فروشگاه ویکو</h4>
            </div>
            <br>
            <div
                class="d-flex mb-3 mr-2-print"
            >
                <div v-if="appliedFilter.date.startDate">
                    <span class="ml-1 font-bold">گزارش فاکتور باز</span>
                    <span>از</span>
                    <span class="font-weight-bold mx-1">تاریخ</span
                        ><span>{{ appliedFilter.date.startDate | persianDate }}</span>
                    </div>
                <div class="mr-2" v-if="appliedFilter.date.endDate">
                    <span>تا</span>
                    <span class="font-weight-bold mx-1">تاریخ</span
                    ><span>{{ appliedFilter.date.endDate | persianDate }}</span>
                </div>
            </div>
            <b-table
                :total-rows="totalRows"
                :per-page="perPage"
                :current-page="currentPage"
                id="main-table"
                v-if="reports"
                bordered
                striped
                :fields="fields"
                :items="reports"
                :filter="filter.search"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter-included-fields="['title', 'id']"
                responsive="sm"
            >
                <template v-slot:cell(id)="data">  
                    <a  
                    :href="`/admin/shop/orders/${data.item.id}`"  
                    class="btn btn-primary"  
                    target="_blank"  
                    rel="noopener noreferrer"  
                >{{ data.item.id }}</a>  
                </template>  
                <template v-slot:cell(name)="data">
                    {{ data.item.customer.full_name }}
                </template>
                <template v-slot:cell(mobile)="data">
                    {{ data.item.customer.mobile}}
                </template>
                <template v-slot:cell(total)="data">
                    {{ data.item.total | price}}
                </template>
                <template v-slot:cell(sum_refund)="data">
                    {{ data.item.sum_refund | price}}
                </template>
                <template v-slot:cell(buy_price)="data">
                    {{ data.item.buy_price | price }}
                </template>
                <template v-slot:cell(discount_amount)="data">
                    {{ data.item.discount_amount | price }}
                </template>
                <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at | persianDate }}
                </template>
                <template v-slot:cell(description)="data">  
                    <span v-if="data.item.description !== 'null'">  
                        {{ data.item.description }}  
                    </span>  
                    <span v-else>-</span>  
                </template>
                <template #bottom-row="data"> 
                    <b-td colspan="4">
                        <div class="text-center">جمع کل:</div>
                    </b-td> 
                    <b-td>{{ totals.purchase_count | price }}</b-td>  
                    <b-td>{{ totals.discount_total | price }}</b-td>  
                    <b-td>*</b-td>  
                    <b-td>{{ totals.total | price }}</b-td>  
                    <b-td>*</b-td>  
                </template>  
            </b-table>
                <div v-if="reports && !reports.length" class="alert alert-primary">  
                    اطلاعاتی موجود نیست
                </div>
            </div>
        <div class="d-flex flex-column w-100"></div>
        </div>
    </main>
</template>
<script>
    import { BTable, BFormGroup, BFormInput, BTd, BPagination } from "bootstrap-vue";
    import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
    import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
    import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";

    function Filter() {
        this.search = "";
        this.date = {
        startDate: "",
        endDate: "",
        };
    }

    Filter.prototype.set = function(filters) {
        Object.entries(filters).forEach(([index, value]) => {
        this[index] = value;
        });
    };

    export default {
        name: "OpensFactor",
        components: {
        ExcelDownload,
        BTd,
        DatePickerRange,
        BTable,
        BFormGroup,
        BFormInput,
        BPagination,
        CustomerSearch,
        },
        data() {
        return {
            disabled: false,
            fields: [
            {
                key: "id",
                label: "شناسه",
            },
            {
                key: "name",
                label: "نام",
            },
            {
                key: "mobile",
                label: "شماره",
            },
            {
                key: "sum_refund_quantity",
                label: "تعداد مرجوعی",
            },
            {
                key: "total_quantity",
                label: "تعداد فروش",
            },
            {
                key: "discount_amount",
                label: "تخفیف (تومان)",
            },
            {
                key: "sum_refund",
                label: "مبلغ مرجوعی (تومان)",
            },
            {
                key: "total",
                label: "مبلغ فاکتور (تومان)",
            },
            {
                key: "created_at",
                label: "تاریخ ثبت",
            },
            ],
            page: 1,
            perPage: 200,
            totals: null,
            selectedCustomer: null,
            reports: null,
            has_discount: null,
            sortBy: null,
            miniOrderId: null,
            sortDesc: null,
            filter: new Filter(),
            appliedFilter: new Filter(),
            currentPage: 1,
        };
        },
        created() {
            this.loadData();
        },
        computed: {
            extraQuery() {
                return {
                start_date: this.filter.date.startDate,
                end_date: this.filter.date.endDate,
                };
            },
            totalRows() {
                return this.reports ? this.reports.length : 0;
            },
        },
        methods: {
            print() {
                window.print();  
            },
            doFilter() {
                this.loadData();
            },
            async loadData() {
                try {
                this.appliedFilter.set(this.filter);
                this.disabled = true;
                const today = new Date();  
                const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);  

                function formatDate(date) {  
                    const year = date.getFullYear();  
                    const month = String(date.getMonth() + 1).padStart(2, '0');  
                    const day = String(date.getDate()).padStart(2, '0');  
                    const hours = String(date.getHours()).padStart(2, '0');  
                    const minutes = String(date.getMinutes()).padStart(2, '0');  
                    const seconds = String(date.getSeconds()).padStart(2, '0');  

                    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
                }  
                if (!this.appliedFilter.date.startDate || !this.appliedFilter.date.endDate) {  
                    this.appliedFilter.date.startDate = formatDate(startOfToday);  
                    this.appliedFilter.date.endDate = formatDate(today);  
                }  
                const response = await this.$axios.get("admin/reports/opens-new", {
                    params: {
                        start_date: this.appliedFilter.date.startDate,
                        end_date: this.appliedFilter.date.endDate,
                        id: this.miniOrderId,
                        customer_id: this.selectedCustomer
                            ? this.selectedCustomer.id
                        : "",
                    },
                });
                this.reports = response.data.data.mini_orders;
                this.totals = response.data.data.totals;
                } catch (e) {
                this.$root.notify(e);
                } finally {
                this.disabled = false;
                }
            },
        },
    };
</script>
<style>
    .print-only {
        display: none;
    }
    @media print {
        .not-in-print {
            display: none !important;
        }

        .app-content .side-app {
            padding: 0 !important;
        }

        .print-only {
            display: flex;
            justify-content: center; 
        }

        body * {
            visibility: hidden;
        }
        #print,
        #print * {
            visibility: visible;
            font-size: 1.25rem;
        }
        #print {
            padding: 0 !important;
        }
        #print {
            width: 100%;
        }

        #print .not-in-print {
            display: none;
        }

        .mr-2-print {
            margin-right: 20px;
        }
    }
</style>